/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountBill,
  BillBreakdownLine,
  BillEmail,
  BillsZipLinkResponse,
  FileContainer,
  UnbilledReadingCostsResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Retrieve a link to download a zip file containing all the bills for a given account
 */
export const getBillsZipLinkByBillingAccountId = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<BillsZipLinkResponse>>,
) => {
  return backofficeRequest<BillsZipLinkResponse>(
    { url: `/billing/${billingAccountId}/bills-zip-file-link`, method: "GET" },
    options,
  )
}
/**
 * @summary Retrieve unbilled reading costs for a given billing account
 */
export const getUnbilledReadingCostsByBillingAccountId = (
  billingAccountId: number,
  options?: SecondParameter<
    typeof backofficeRequest<UnbilledReadingCostsResponse>
  >,
) => {
  return backofficeRequest<UnbilledReadingCostsResponse>(
    {
      url: `/accounts/${billingAccountId}/unbilled-reading-costs`,
      method: "GET",
    },
    options,
  )
}
/**
 * @summary Get bills for an account.
 */
export const getAccountBills = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<AccountBill[]>>,
) => {
  return backofficeRequest<AccountBill[]>(
    { url: `/api/v1/accounts/${billingAccountId}/bills`, method: "GET" },
    options,
  )
}
/**
 * @summary Get breakdown lines for a bill.
 */
export const getAccountBillBreakdown = (
  billId: number,
  options?: SecondParameter<typeof backofficeRequest<BillBreakdownLine[]>>,
) => {
  return backofficeRequest<BillBreakdownLine[]>(
    { url: `/api/v1/bills/${billId}/breakdown`, method: "GET" },
    options,
  )
}
/**
 * @summary Get a bill by ID for an account.
 */
export const getAccountBill = (
  billingAccountId: number,
  billId: number,
  options?: SecondParameter<typeof backofficeRequest<AccountBill>>,
) => {
  return backofficeRequest<AccountBill>(
    {
      url: `/api/v1/accounts/${billingAccountId}/bills/${billId}`,
      method: "GET",
    },
    options,
  )
}
/**
 * @summary Get the notification email metadata for a bill.
 */
export const getAccountBillEmail = (
  billId: number,
  options?: SecondParameter<typeof backofficeRequest<BillEmail>>,
) => {
  return backofficeRequest<BillEmail>(
    { url: `/api/v1/bills/${billId}/email`, method: "GET" },
    options,
  )
}
/**
 * @summary Get the PDF image for a bill.
 */
export const getAccountBillImage = (
  billId: number,
  options?: SecondParameter<typeof backofficeRequest<FileContainer>>,
) => {
  return backofficeRequest<FileContainer>(
    { url: `/api/v1/bills/${billId}/image`, method: "GET" },
    options,
  )
}
export type GetBillsZipLinkByBillingAccountIdResult = NonNullable<
  Awaited<ReturnType<typeof getBillsZipLinkByBillingAccountId>>
>
export type GetUnbilledReadingCostsByBillingAccountIdResult = NonNullable<
  Awaited<ReturnType<typeof getUnbilledReadingCostsByBillingAccountId>>
>
export type GetAccountBillsResult = NonNullable<
  Awaited<ReturnType<typeof getAccountBills>>
>
export type GetAccountBillBreakdownResult = NonNullable<
  Awaited<ReturnType<typeof getAccountBillBreakdown>>
>
export type GetAccountBillResult = NonNullable<
  Awaited<ReturnType<typeof getAccountBill>>
>
export type GetAccountBillEmailResult = NonNullable<
  Awaited<ReturnType<typeof getAccountBillEmail>>
>
export type GetAccountBillImageResult = NonNullable<
  Awaited<ReturnType<typeof getAccountBillImage>>
>
